import { useEffect, useState } from "react";

function EventSettings({ competitionElemProps }: { competitionElemProps: any }) {
    const [competitionData, setcompetitionData] = useState([]);

    const onSetSettingsText = (e: any) => {
        let items = [...competitionData];

        let value = e.target.value;
        let data = e.target.dataset.name;
        let index = Number(e.target.dataset.index);
        
        // @ts-ignore
        let item = {...items[index]};
        // @ts-ignore
        item[data] = value;

        // @ts-ignore
        items[index] = item;

        setcompetitionData(items);
    }

    const saveUpdatedData = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(competitionData)
        };
        fetch('/api/competitions/update', requestOptions)
            .then(response => response.json())
            .then(data => alert("Successfully saved your competitions."));

        competitionElemProps.handleUpdate();
    }

    const handleBack = () => {
        competitionElemProps.handleBackButton();
    }

    useEffect(() => {
        setcompetitionData(competitionElemProps.competitionData);
    }, [competitionElemProps.competitionData]);

    return (
        <div className="settings-view-wrapper" style={{ display: (competitionElemProps.show) ? "block" : "none" }}>
            <div className="pfgame-dashboard-view__content-wrapper--welcome d-flex flex-align-right">
                <button type="submit" className="pfgame-main-button btn-dark" onClick={handleBack}>Back to Competition List</button>
            </div>

            {(competitionData.length > 0) ? (competitionData.map((competition: any, index: number) => (
                <div className="settings-form">
                    <h1 className="text-center mb-5">Event Details and Settings</h1>

                    <div className="form-group">
                        <div className="form-group__elem">
                            <div className="data-table-datas__elem--col">
                                <p><span className="mr-8">Event ID: #</span><span>{competition.id}</span></p>
                            </div>
                        </div>
                        
                        <div className="form-group__elem">
                            <label>Name:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="text" className="mini-data-input" value={competitionData[index]["name"]} onChange={onSetSettingsText} data-name="name" data-index={index} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-group__elem">
                            <label>Created By:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="text" className="mini-data-input" value={competitionData[index]["created_by"]} onChange={onSetSettingsText} data-name="created_by" data-index={index} />
                            </div>
                        </div>

                        <div className="form-group__elem">
                            <div className="data-table-datas__elem--col">
                                <p><span className="mr-8">Created At:</span><span>{competition.created_at.substring(0, 10)}</span></p>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-group__elem">
                            <label>Starts At Date:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="datetime-local" className="pfgame-main-input" value={competitionData[index]["starts_at_date"]} onChange={onSetSettingsText} data-name="starts_at_date" data-index={index} />
                            </div>
                        </div>

                        <div className="form-group__elem">
                            <label>Ends At Date:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="datetime-local" className="pfgame-main-input" value={competitionData[index]["ends_at_date"]} onChange={onSetSettingsText} data-name="ends_at_date" data-index={index} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-group__elem">
                            <label>Winnder Performer ID:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="number" className="mini-data-input" value={competitionData[index]["winner_perfid"]} onChange={onSetSettingsText} data-name="winner_perfid" data-index={index} />
                            </div>
                        </div>

                        <div className="form-group__elem">
                            <label>The amount of Credits served for the Event:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="number" className="mini-data-input" value={competitionData[index]["amount_credits_won"]} onChange={onSetSettingsText} data-name="amount_credits_won" data-index={index} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-group__elem">
                            <label>Event Status:</label>

                            <div className="data-table-datas__elem--col">
                                <select className="mini-data-input" onChange={onSetSettingsText} data-name="status" data-index={index}>
                                    <option value="active" selected={(competitionData[index]["status"] === "active") ? true : false}>
                                        Active
                                    </option>
                                    <option value="expired" selected={(competitionData[index]["status"] === "expired") ? true : false}>
                                        Expired
                                    </option>
                                    <option value="disabled" selected={(competitionData[index]["status"] === "disabled") ? true : false}>
                                        Disabled
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group__elem">
                            <label>English Name:</label>

                            <div className="data-table-datas__elem--col">
                                <input type="text" className="mini-data-input" value={competitionData[index]["english_name"]} onChange={onSetSettingsText} data-name="english_name" data-index={index} />
                            </div>
                        </div>
                    </div>

                    <div className="pfgame-dashboard-view__content-wrapper--welcome d-flex flex-align-right">
                        <button type="submit" className="pfgame-main-button btn-green mb-5" onClick={saveUpdatedData}>Save</button>
                    </div>
                </div>
            ))) : (
                <p className="text-center">Loading settings form...</p>
            )}
        </div>
    )
}

export { EventSettings };